import { ConfigurationManager } from "../ConfigurationManager";
import { Game } from "./Game";
import {} from "./ImageEntity";
export var SLOT_TYPES;
(function (SLOT_TYPES) {
    SLOT_TYPES["TEXTURE"] = "texture";
    SLOT_TYPES["OBJECT_3D"] = "object_3d";
    SLOT_TYPES["COMPLEX"] = "complex";
})(SLOT_TYPES || (SLOT_TYPES = {}));
export class SlotData {
    id;
    name;
    type;
    dimensions;
    transparency;
    screenshots;
    description;
    gameId;
    prompt;
    slots;
}
export class Slot extends SlotData {
    constructor(data = null) {
        super();
        if (data) {
            for (let key in data) {
                this[key] = data[key];
            }
        }
    }
    get game() {
        return ConfigurationManager.getInstance().gamesController.getGame(this.gameId);
    }
    async isOwner(user) {
        let game = await this.game;
        return user.getCompanyId() == game.publisher || user.getCompanyId() == game.developer || user.isAdmin();
    }
}
